import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IColumnFeatureItem {
	image?: IImage;
	heading?: string;
	/**
	 * Text
	 * @control richtext
	 */
	text?: string;
}

export interface IThreeColumnFeatureProps extends IBaseElementProps {
	mainBackgroundImage?: IImage;
	columnFeatureItems?: IColumnFeatureItem[];
}

/**
 * Calian Three Column Feature
 * @block
 * @icon columns
 */
const ThreeColumnFeature: React.FC<IThreeColumnFeatureProps> = ({
	id,
	className,
	classNames = [],
	mainBackgroundImage,
	columnFeatureItems,
}) => (
	<div
		id={id}
		className={
			className ||
			cn(
				`three-column-feature overflow-hidden ${
					mainBackgroundImage ? 'position-relative py-6 py-lg-12' : ''
				}`,
				...classNames,
			)
		}
	>
		{mainBackgroundImage && (
			<>
				<div
					className="position-absolute top-0 bottom-0 end-0"
					style={{ filter: 'blur(0.5rem)' }}
				>
					<Image
						className="img-fluid h-100 object-fit-cover"
						{...mainBackgroundImage}
					/>
				</div>
				<div
					className={`position-absolute top-0 bottom-0 end-0 w-100 overlay`}
				></div>
			</>
		)}
		<div className="container-fluid mw-1260px position-relative">
			<div className="row" style={{ rowGap: '2rem' }}>
				{columnFeatureItems?.map((item, index) => (
					<div
						key={index}
						className="col-12 col-lg-4 px-lg-4 px-xl-6 d-flex flex-column flex-sm-row flex-lg-column"
					>
						{item.image && item.image.src && (
							<Image
								className="three-column-feature__image mw-220px w-100 h-auto aspect-ratio-1-1 aspect-ratio img-fluid rounded-5 mb-5 text-center align-self-center align-self-lg-start"
								{...item.image}
							/>
						)}
						<div className="ms-sm-6 ms-lg-0">
							{item.heading && (
								<h3 className="three-column-feature__heading">
									{item.heading}
								</h3>
							)}
							{item.text && (
								<p
									className="three-column-feature__text mb-0"
									dangerouslySetInnerHTML={{
										__html: item.text,
									}}
								/>
							)}
						</div>
					</div>
				))}
			</div>
		</div>
	</div>
);

export default ThreeColumnFeature;
